var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "validation-observer",
        { ref: "form" },
        [
          _c(
            "b-form",
            {
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "w-full flex gap-2 justify-end" },
                [
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "ripple",
                          rawName: "v-ripple.400",
                          value: "rgba(255, 255, 255, 0.15)",
                          expression: "'rgba(255, 255, 255, 0.15)'",
                          modifiers: { 400: true },
                        },
                      ],
                      staticClass: "float-right",
                      attrs: { variant: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.showTeacherPopupSearch = true
                        },
                      },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "SearchIcon" },
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v("Buscar"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
      _c("teacher-popup", {
        attrs: {
          visible: _vm.showTeacherPopupSearch,
          filters: _vm.filtersGridTeacher,
        },
        on: { selected: _vm.addTeachersList, close: _vm.closePopup },
      }),
      _c("div", { staticClass: "vx-row mt-4 mb-10" }, [
        _c(
          "div",
          { staticClass: "vx-col w-full" },
          [
            _c(
              "vs-table",
              {
                attrs: {
                  data: _vm.teachersList,
                  "no-data-text": "Nenhum registro encontrado",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var data = ref.data
                      return _vm._l(data, function (tr, indextr) {
                        return _c(
                          "vs-tr",
                          { key: indextr },
                          [
                            _c("vs-td", [_vm._v(_vm._s(data[indextr].name))]),
                            _c("vs-td", [_vm._v(_vm._s(data[indextr].email))]),
                            _c("vs-td", [
                              _c(
                                "div",
                                { staticClass: "flex flex-row gap-2" },
                                [
                                  _c("feather-icon", {
                                    staticClass:
                                      "h-5 w-5 mr-1 stroke-current text-danger",
                                    staticStyle: { cursor: "pointer" },
                                    attrs: { icon: "Trash2Icon" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.destroy(data[indextr])
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        )
                      })
                    },
                  },
                ]),
              },
              [
                _c(
                  "template",
                  { slot: "thead" },
                  [
                    _c("vs-th", [_vm._v("Nome")]),
                    _c("vs-th", [_vm._v("E-mail")]),
                    _c("vs-th", [_vm._v("Ação")]),
                  ],
                  1
                ),
              ],
              2
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }